import { useLocation } from "react-router-dom";

import Cases from "./Cases";
import CasesFullscreen from "./CasesFullscreen";

const CasesModule = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isFullscreen = queryParams.get("fullscreen");

  if (isFullscreen) {
    return <CasesFullscreen />;
  }

  return <Cases />;
};
export default CasesModule;
